import * as React from "react";
import Popover from "@mui/material/Popover";
import "./popover.scss";

export default function PopOver({ children, trigger }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <div
        className="popover-count"
        aria-describedby={id}
        onClick={handleClick}
      >
        ({trigger})
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div className="popover-content">{children}</div>
      </Popover>
    </div>
  );
}
